import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import { ListGroupItem, Row, Col, Input } from 'reactstrap';
import ReactPlayer from 'react-player'

import VideoControls from './VideoControls'

export default class ConntentPlayer extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      error : '',
      usingThumbNails : true,
      mainOpacityStart : 2,
      introFadeStart : 8,
      introFadeDuration : 0.25,
      outroFadeStart : 4.5,
      outroFadeDuration : 0.25
    };
    this.goToList = this.goToList.bind(this)
    this.handlePlayPause = this.handlePlayPause.bind(this);
    this.shareClicked = this.shareClicked.bind(this);

    this.outroVideoRef = React.createRef();

  }

  componentDidMount(){

  }

  goToList(){
    window.dataLayer.push({
      eventCategory: 'video',
      eventAction: 'clicInterne',
      eventLabel: 'nouvelleListe',
      event: 'genericGAEvent'
    });

    this.props.stopper()
    this.props.query.push('/?')
  }

  handlePlayPause(e){
    e.preventDefault();
    if(this.props.isPlaying){
      this.props.pauser();
    }else{
      this.props.handler();
    }
  }

  shareClicked(e) {
    if(navigator.share){
      try{
        navigator.share({
          url: window.location.href,
          text: "",
          title: ""
        });
      }catch(err){
        this.props.shareAlternative();
      }
    } else {
      this.props.shareAlternative();
    }

    window.dataLayer.push({
      eventCategory: 'video',
      eventAction: 'clicSocial',
      eventLabel: 'partagerVideo - ' + this.props.query.location.search.substring(1),
      event: 'genericGAEvent'
    });

  }

  /*shareClicked(e) {
    this.shareWithImage();
  }

  async shareWithImage() {
    const response = await fetch('/assets/branding/share.jpg');
    const blob = await response.blob();
    const filesArray = [
      new File(
        [blob],
        'share.jpg',
        {
          type: "image/jpeg",
          lastModified: new Date().getTime()
        }
     )
    ];
    const shareData = {
      url: window.location.href,
      text: "Par nul autre que le chœur des Petits mangeurs du Mont-Royal !",
      title: "Faites CHANTER votre liste d’épicerie",
      files: filesArray,
    };
    navigator.share(shareData);
  }*/

  render () {

    let clamp = (value, min,max) => {
      return Math.min(Math.max(value, min), max);
    }

    let mainOpacity = clamp(((this.props.progress * this.props.duration) - this.state.mainOpacityStart), 0 ,1);
    let introOpacity = 1 - clamp(((this.props.progress * this.props.duration) - this.state.introFadeStart) / this.state.introFadeDuration, 0 ,1);



    //Start playing outro 1 second before we fade it in
    let outroPreroll = 0.5;
    let progressInSeconds = this.props.progress * this.props.duration
    let outroPlaying = (this.props.duration - progressInSeconds)  < (this.state.outroFadeStart + outroPreroll);

    if(!outroPlaying){
      if(this.outroVideoRef.current){
        this.outroVideoRef.current.seekTo(0);
      }
    }

    let outroOpacity = clamp(((this.state.outroFadeStart - (this.props.duration - progressInSeconds)) / this.state.outroFadeDuration), 0, 1);
    outroOpacity = clamp(outroOpacity - introOpacity, 0, 1);

    return (
      <React.Fragment>
        <svg style={{position:"absolute"}}width="0" height="0">
          <clipPath id="svgClip" clipPathUnits="objectBoundingBox">
            <path d="M.98773.96707C.99172.95938.99647.95484,1,.95472V.03492C.99646.03483.9917.03029.9877.02257A.04916.04916,0,0,1,.98186,0H.01761A.05551.05551,0,0,1,.01249.01994C.00853.02854.00359.03368,0,.03358V.95606C.0036.95593.00855.96107.01253.9697A.05545.05545,0,0,1,.01768.99006H.9819A.04856.04856,0,0,1,.98773.96707Z"></path>
          </clipPath>
        </svg>

        <img id="" style={{visibility:"hidden"}} src="/assets/branding/logoMangeurs.png" width="15%" className="logoMangeurs"  alt="Ptit mangeurs logo" />

        <div style={{textAlign: "center", width: "100%"}}>
          <div style={{margin:"0 -100%"}}>

            <div className="videoContainer" style={{position:"relative",marginLeft:"auto", marginRight:"auto"}}>

              <div style={{position:"relative"}}>
                <ReactPlayer style={{clipPath: "url(#svgClip)", opacity:mainOpacity, cursor : "pointer"}}
                playsinline
                width="100%"
                height="100%"
                className=""
                onPlay={() => this.props.handler()}
                onClick={this.handlePlayPause}
                loop={true}
                playing={this.props.isPlaying}

                volume={0}
                muted={true}
                muted
                config={{
                  file: {
                    attributes: {
                      muted: true,
                      preload : "auto"
                      }
                    }
                  }
                }
                url='/assets/branding/Chorale_Loop_4s.mp4'/>
                <div style={{
                  position:"absolute",
                  top :0,
                  left: 0,
                  width:"100%",
                  pointerEvents: "none",
                  clipPath: "url(#svgClip)"
                }}>
                  <ReactPlayer style={{clipPath: "url(#svgClip)", pointerEvents:"none", opacity:introOpacity}}
                  playsinline
                  width="100%"
                  height="100%"
                  className=""
                  loop={false}
                  playing={this.props.isPlaying}
                  volume={0}
                  muted={true}
                  muted
                  config={{
                    file: {
                      attributes: {
                        muted: true,
                        preload : "auto"
                        }
                      }
                    }
                  }
                  url='/assets/branding/RideauChoraleCrossfadeIN.mp4'/>
                </div>

                <div style={{
                  position:"absolute",
                  top :0,
                  left: 0,
                  width:"100%",
                  pointerEvents: "none",
                  clipPath: "url(#svgClip)"
                }}>
                  <ReactPlayer ref={this.outroVideoRef} style={{clipPath: "url(#svgClip)", pointerEvents:"none", opacity:outroOpacity}}
                  playsinline
                  width="100%"
                  height="100%"
                  className=""
                  loop={false}
                  playing={outroPlaying && this.props.isPlaying}
                  volume={0}
                  muted={true}
                  config={{
                    file: {
                      attributes: {
                        muted: true,
                        preload : "auto"
                        }
                      }
                    }
                  }
                  url='/assets/branding/RideauChoraleCrossfadeOut.mp4'/>
                </div>

                <div className="mobileHidden" style={{
                  position:"absolute",
                  top :0,
                  left: 0,
                  width:"100%",
                  height:"100%",
                  backgroundImage:"url('/assets/branding/ChoraleVignette.png')",
                  backgroundSize: "100% 100%",
                  pointerEvents: "none",
                  clipPath: "url(#svgClip)"
                }}></div>

                <div className="mobileHidden" style={{
                  position:"absolute",
                  width:"102.5%",
                  height:"103%",
                  transform: "translateX(-1.2%) translateY(-99.1%)",
                  backgroundImage:"url('/assets/branding/videoFrame.png')",
                  backgroundSize: "100% 100%",
                  pointerEvents: "none"
                }}></div>
              </div>
            </div>
          </div>
          <div className="videoControlWrapper">
            <VideoControls  play={this.handlePlayPause}
                            progress={this.props.progress}
                            isPlaying={this.props.isPlaying}
                            isMuted={this.props.isMuted}
                            mute={this.props.mute}/>
            <div className="shareWrapper">
              <div className="shareContainerNoBlockNoBlock" style={{marginTop:"15px"}}>
                <img id="partager" src="/assets/branding/partagerIcon.png" onClick={this.shareClicked} style={{maxHeight:"100px",position:"relative",marginTop:"-35px"}} alt="" />
              </div>
              <div id="partageDons" style={{display:"flex",maxWidth:"285px",marginTop:"-50px"}}>
                <p id="textePartagePlayer" style={{
                fontWeight:"bold",
                textAlign:"left",
                width:"55%"}}>
                  1 LISTE PARTAGÉE = 1 $ POUR LUTTER<br/>CONTRE LA FAIM CHEZ LES ENFANTS
                </p>

              <img id="partageFondationPlayer" src="/assets/branding/fondationSolo.png"  alt="Partage dons" />


              </div>
   <div id="listeNav" style={{float:"right",marginTop:"-40px"}}>
    <a style={{marginRight:"10px"}} onClick={this.goToList}> Nouvelle liste</a>
    <a style={{marginLeft:"10px"}} onClick={this.props.openList}> Consulter la liste</a>
    </div>


            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
